export default __webpack_public_path__ + "static/media/skills-glyph-16px.c3b4c273.svg";